import {
  PORTALUSERS_GET,
  PORTALUSER_GET,
  PORTALUSER_CLASSYEARS_GET,
  PORTALUSER_EDIT,
  PORTALUSER_DELETE,
  PORTALUSER_ORTU_DELETE,
  PORTALUSER_SYNC,
  PORTALUSER_VAL_DATA,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
  portalusersSync: [],
  portalusersMerge: [],
  portaluserExisting: [],
  jenjangs: [],
  kelass: [],
  years: [],
  sems: [],
  classyears: [],
};

const portalusersGet = (state, payload) => {
  const portalusers = payload.portalusers;
  return {
    ...state,
    total: portalusers.total,
    items: [...portalusers.items],
    search: { ...portalusers.search },
  };
};

const portaluserGet = (state, payload) => {
  return {
    ...state,
    total: state.total,
    items: [
      ...state.items.filter(
        (i) => i.userId + '' !== payload.portaluser.userId + ''
      ),
      payload.portaluser,
    ],
    search: { ...state.search },
  };
};

const portaluserClassyearsGet = (state, payload) => {
  let rawClassyears = payload.classyears;

  const id = rawClassyears.id;
  const classyears = rawClassyears.classyears;
  const jenjangs = rawClassyears.jenjangs;
  const kelass = rawClassyears.kelass;
  const years = rawClassyears.years;
  const sems = rawClassyears.sems;

  let updateClassyears = [];
  if (classyears) {
    let initClassyears = state.classyears;
    let filterClassyears =
      (initClassyears &&
        initClassyears[0] &&
        initClassyears.filter((c) => c.id !== id)) ??
      [];
    updateClassyears = [...filterClassyears, { id, history: classyears }];
  }

  let newState = {
    ...state,
  };
  if (jenjangs) {
    newState.jenjangs = jenjangs;
  }
  if (kelass) {
    newState.kelass = kelass;
  }
  if (years) {
    newState.years = years;
  }
  if (classyears) {
    newState.classyears = updateClassyears;
  }
  if (sems) {
    newState.sems = sems;
  }
  return {
    ...state,
    classyears: updateClassyears,
    jenjangs,
    kelass,
    years,
    sems,
  };
};

const portaluserEdit = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total),
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.portaluser.id + ''),
      payload.portaluser,
    ],
    search: { ...state.search },
  };
};

const portaluserDelete = (state, payload) => {
  let item = state.items.find(
    (i) => i.userId + '' === payload.portaluser.userId + ''
  );

  if (!item) return;

  let updateItem = {
    ...item,
    messages: item?.messages?.filter(
      (m) => m.id + '' !== payload.portaluser.id + ''
    ),
  };

  return {
    ...state,
    total: parseInt(state.total),
    items: [
      ...state.items.filter(
        (i) => i.userId + '' !== payload.portaluser.userId + ''
      ),
      updateItem,
    ],
    search: { ...state.search },
  };
};

const portaluserOrtuDelete = (state, payload) => {
  let item = state.items.find(
    (i) => i.userId + '' === payload.portaluser.userId + ''
  );

  if (!item) return;

  let updateItem = {
    ...item,
    portaluserOrtu: item?.portaluserOrtu?.filter(
      (puOrtu) => puOrtu.id + '' !== payload.portaluser.portaluserOrtu?.id + ''
    ),
  };

  return {
    ...state,
    total: parseInt(state.total),
    items: [
      ...state.items.filter(
        (i) => i.userId + '' !== payload.portaluser.userId + ''
      ),
      updateItem,
    ],
    search: { ...state.search },
  };
};

const portaluserSync = (state, payload) => {
  let dataPortalusersSync = payload?.portaluser?.portalusersSync;
  let dataPortalusersExisting = payload?.portaluser?.portalusers;
  let portalusersMerge = [];
  for (const el of dataPortalusersSync) {
    let dataExist = dataPortalusersExisting?.find((dt) => {
      return dt.userId + '' === el.USERID + '';
    });
    let id = '';
    let deviceId = '';
    let newHistoryClass = [];
    if (dataExist) {
      id = dataExist.id;
      deviceId = dataExist.deviceId;
      let historyClass =
        dataExist?.description?.historyClass &&
        dataExist?.description?.historyClass[0]
          ? dataExist?.description?.historyClass
          : [];
      newHistoryClass = [
        ...historyClass.filter((h) => h.class !== el.KELAS_AKTIF),
        { class: el.KELAS_AKTIF },
      ];
    } else {
      newHistoryClass = [{ class: el.KELAS_AKTIF }];
    }
    portalusersMerge.push({
      id,
      deviceId,
      userId: el?.USERID,
      username: el?.VUSN || el.NIS,
      nis: el.NIS,
      name: el.NAMA_SISWA,
      activeClass: el.KELAS_AKTIF,
      description: {
        nis: el.NIS,
        noAbsen: el.NO_ABSEN,
        name: el.NAMA_SISWA,
        fatherName: el.NAMA_AYAH,
        fatherPhoneNumber: el.NO_HP_AYAH,
        motherName: el.NAMA_IBU,
        motherPhoneNumber: el.NO_HP_IBU,
        guardianName: el.NAMA_WALI,
        guardianPhoneNumber: el.NO_HP_WALI,
        activeClass: el.KELAS_AKTIF,
        historyClass: newHistoryClass,
      },
      selected: true,
    });
  }

  return {
    ...state,
    items: [...payload?.portaluser?.portalusers],
    portalusersSync: [...payload?.portaluser?.portalusersSync],
    portalusersMerge: [...portalusersMerge],
  };
};

const portaluserValData = (state, payload) => {
  let portaluserExisting = payload.valData.portaluserExisting ?? [];
  let jenjangs = payload.valData.jenjangs ?? [];
  let kelass = payload.valData.kelass ?? [];
  let years = payload.valData.years ?? [];
  let sems = payload.valData.sems ?? [];

  return {
    ...state,
    portaluserExisting,
    jenjangs,
    kelass,
    years,
    sems,
  };
};

export default createReducer(initialState, {
  [PORTALUSERS_GET]: portalusersGet,
  [PORTALUSER_GET]: portaluserGet,
  [PORTALUSER_CLASSYEARS_GET]: portaluserClassyearsGet,
  [PORTALUSER_EDIT]: portaluserEdit,
  [PORTALUSER_DELETE]: portaluserDelete,
  [PORTALUSER_ORTU_DELETE]: portaluserOrtuDelete,
  [PORTALUSER_SYNC]: portaluserSync,
  [PORTALUSER_VAL_DATA]: portaluserValData,
});
